import { useEffect, useState, useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import { LocalStorage } from '../../services/localStorage/LocalStorage.services'
import { catalan_calendar } from '../../utils/editDatePicker'

import { Calendar, DateObject } from "react-multi-date-picker"
import Button from '../../components/UI/Button'
import Filter from '../../components/Filter/Filter'
import DailyList from './DailyList'

import getAllTasks from '../../services/tasks/getAllTasks'
import getAllTasksByUserId from '../../services/tasks/getAllTasksByUserId'
import desactiveTasks from '../../services/tasks/desactiveTasks'
import getAllTipus from '../../services/tipus/getAllTipus'
import getAllArees from '../../services/arees/getAllArees'
import getAllLabels from '../../services/labels/getAllLabels'
import getAllProfessionals from '../../services/professionals/getAllProfessionals'

import styles from './Daily.module.css'

const Daily = () => {

  const componentRef = useRef()

  const [ tasks, setTasks ] = useState([])
  const [ tasksFiltered, setTasksFiltered ] = useState([])
  const [ tasksFiltered1, setTasksFiltered1 ] = useState([])
  const [ tasksFiltered2, setTasksFiltered2 ] = useState([])
  const [ tasksFiltered3, setTasksFiltered3 ] = useState([])
  const [ tasksFiltered4, setTasksFiltered4 ] = useState([])
  const [ professionals, setProfessionals ] = useState([])
  const [ tipus, setTipus ] = useState([])
  const [ arees, setArees ] = useState([])
  const [ labels, setLabels ] = useState([])
  const [ update, setUpdate ] = useState(false)
  const [ visible, setVisible ] = useState(false)
  const [ visible2, setVisible2 ] = useState(false)

  useEffect(() => {
    if (LocalStorage.getItem("professionalProfile") === "Superadministrador" || LocalStorage.getItem("professionalProfile") === "Administrador") {
      getAllTasks()
      .then(tasks => {
        setTasks(tasks)
        setTasksFiltered(tasks)
        setTasksFiltered1(tasks)
        setTasksFiltered2(tasks)
        setTasksFiltered3(tasks)
        setTasksFiltered4(tasks)
      })
    } else {
      getAllTasksByUserId(LocalStorage.getItem("id"))
      .then(tasks => {
        setTasks(tasks)
        setTasksFiltered(tasks)
        setTasksFiltered1(tasks)
        setTasksFiltered2(tasks)
        setTasksFiltered3(tasks)
        setTasksFiltered4(tasks)
      })
    }
    getAllProfessionals()
    .then(elements => {
      if (LocalStorage.getItem("professionalProfile") !== "Superadministrador") {
        const professionalAuth = elements.filter( element => element.professionalProfile !== "Superadministrador" &&  element.professionalProfile !== "Bot" )
        setProfessionals(professionalAuth)
      } else {
        setProfessionals(elements)
      }
    })
    getAllTipus()
    .then(elements => {
      setTipus(elements)
    })
    getAllArees()
    .then(elements => {
      setArees(elements)
    })
    getAllLabels()
    .then(elements => {
      setLabels(elements)
    })
  },[update])

  // Actualizar els seguimients filtrats combinant ambdos filtres
  useEffect(() => {
    console.log('task1', tasksFiltered1,'task2', tasksFiltered2,'task3', tasksFiltered3,'task4', tasksFiltered4)
    const uniqueValues = getCommonValues(tasksFiltered1, tasksFiltered2, tasksFiltered3, tasksFiltered4)
    setTasksFiltered(uniqueValues)
  }, [tasksFiltered1, tasksFiltered2, tasksFiltered3, tasksFiltered4])

  const handleDesactive = (event) => {
    const id = event.target.id
    desactiveTasks(id)
    setUpdate(!update)
  }

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "Daily de tasques",
    onafterprint: () => alert('Print success')
  })
  
  function getCommonValues(...arrays) {
    return arrays.reduce((acc, currentArray) => {
      return acc.filter((value) => currentArray.includes(value))
    })
  }

  // Función para hacer funcionar el filtro de elementos => por projecte
  const handleChangeProjecte = (value) => {
    if (value.length !== 0) {
      let tasksFiltereds = tasks.filter(element => value.includes(element.taskAreaId._id)) 
      setTasksFiltered1(tasksFiltereds)
    } else {
      setTasksFiltered1(tasks)
    }
  } 

  // Placeholder del filtro de projecte
  const placeholderFilterProjecte = "Filtre projecte"

  // Array con los elementos del filtro de projecte
  const dataProjecte = arees.map(element => {
    return {
      label: `${element.areaName}`,
      value: element._id
    }
  })

  // Función para hacer funcionar el filtro de elementos => por professional
  const handleChangeProfessional = (value) => {
    if (value.length !== 0) {
      let tasksFiltereds = tasks.filter(element => value.includes(element?.taskProfessionalId?._id)) 
      setTasksFiltered2(tasksFiltereds)
    } else {
      setTasksFiltered2(tasks)
    }
  }

  // Placeholder del filtro de professional
  const placeholderFilterProfessional = "Filtre professional"

  // Array con los elementos del filtro de professional
  const dataProfessional = professionals.map(element => {
    return {
      label: `${element.professionalName} ${element.professionalLastName1} ${element.professionalLastName2}`,
      value: element._id
    }
  })
  
  // Función para hacer funcionar el filtro de elementos => por etiquetes
  const handleChangeLabels = (value) => {
    if (value.length !== 0) {
      let tasksFiltereds = tasks.filter(element => element.taskLabelId.some(label => value.includes(label._id)))
      setTasksFiltered3(tasksFiltereds)
    } else {
      setTasksFiltered3(tasks)
    }
  }

  // Placeholder del filtro de tipus de etiquetes
  const placeholderFilterLabels = "Filtre d'etiqueta"

  // Array con los elementos del filtro de tipus de competencia
  const dataLabels = labels.map(element => {
    return {
      label: `${element.labelName}`,
      value: element._id
    }
  })

  // Función para hacer funcionar el filtro de elementos => por estat
  const handleChangeState = (value) => {
    if (value.length !== 0) {
      console.log(tasks)
      let tasksFiltereds = tasks.filter(element => value.includes(element.taskStatus))
      setTasksFiltered4(tasksFiltereds)
    } else {
      setTasksFiltered4(tasks)
    }
  }

  // Placeholder del filtro de estat
  const placeholderStatus = "Filtre estat tasca"

  // Array con los elementos del filtro de estat
  const dataStatus = [
    {
      label: "Pendent",
      value: true,
    },
    {
      label: "Realitzat",
      value: false,
    },
  ]

  const handleVisible = () => {
    setVisible(!visible)
  }

  // const handleDateClick = (date) => {
  //   const selectedDate = new Date(date.unix * 1000).toDateString()
  //   const filteredTasks = tasks.filter(task => {
  //     const taskDate = new Date(task.taskPlanningDate).toDateString()
  //     return taskDate === selectedDate
  //   })
  //   setTasksFiltered5(filteredTasks)
  // }

  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <div onClick={handleVisible} className={styles.icons}>
          {visible ? <i class="fa-solid fa-eye-slash"></i> : <i onClick={handleVisible} class="fa-solid fa-eye"></i>}
        </div>
        <div className={visible ? styles.filters : styles.disable}>
          <div className={styles.multiselector}>
            <Filter
              data={dataProjecte} 
              handleChange={handleChangeProjecte}
              placeholderFilter={placeholderFilterProjecte}
              type='multiple'
            />
          </div>
          <div className={styles.multiselector}>
            <Filter
              data={dataProfessional} 
              handleChange={handleChangeProfessional}
              placeholderFilter={placeholderFilterProfessional}
              value={LocalStorage.getItem("id")}
              type='multiple'
            />
          </div>
          <div className={styles.multiselector}>
            <Filter
              data={dataLabels} 
              handleChange={handleChangeLabels}
              placeholderFilter={placeholderFilterLabels}
              type='multiple'
            />
          </div>
          <div className={styles.multiselector}>
            <Filter
              data={dataStatus} 
              handleChange={handleChangeState}
              placeholderFilter={placeholderStatus}
              type='multiple'
            />
          </div>
        </div>
        <div className={styles.button}>
            <Button handleOnClick={() => setVisible2(!visible2)} icon={visible2 === false ? "fa-calendar-plus" : "fa-calendar-minus"}/>
            <Button handleOnClick={handlePrint} icon={"fa-print"}/>
            <Button path="/tasques/new-tasca" icon={"fa-circle-plus"}/>
        </div>
      </div>
      <div className={visible2 === true ? styles.multipleCalendar : styles.disable} >
        <Calendar 
          className={styles.calendar}
          numberOfMonths={5}
          locale={catalan_calendar}
          weekStartDayIndex={1}
          displayWeekNumbers="enable"
          currentDate={new DateObject({ date: new Date() })}
          currentDatePosition={3}
          mapDays={({ date }) => {
            let props = {}
            const dateCalendar = new Date(date.unix * 1000).toDateString()
            if (tasks) {
              const dateArray = tasksFiltered && tasksFiltered.map(element => {
                  const data = new Date(element.taskPlanningDate)
                  return data.toDateString()
                })
              const result = {}
              dateArray.forEach((value) => {
                result[value] = (result[value] || 0) + 1
              })
              for (let index = 0; index < Object.keys(result).length; index++) {
                const data = Object.keys(result)
                const dataString = new Date(data[index]).toDateString()
                const value = Object.values(result)
                const valueString = value[index]
                if (dateCalendar === dataString) {
                  if (valueString <= 3) {
                    props.style = {
                      backgroundColor: "#57cc99",
                    }
                  } else if (valueString > 3 && valueString <= 5 ) {
                    props.style = {
                      backgroundColor: "#ffba08",
                    }
                  } else {
                    props.style = {
                      backgroundColor: "#dc2f02",
                    }
                  }
                }
              }
            }
            return props
          }}
        />    
      </div>
      <div className={visible2 === true ? styles.info : styles.disable}>
        <span><i className={"fa-solid fa-circle"} id={styles.info1}></i> &#60; 3 tasques</span>
        <span><i className={"fa-solid fa-circle"} id={styles.info2}></i> Entre 3 i 6 tasques</span>
        <span><i className={"fa-solid fa-circle"} id={styles.info3}></i> &#62; 6 tasques</span>
      </div>
      <div className={styles.listElements} ref={componentRef}>
        <DailyList tasks={tasksFiltered} handleDesactive={handleDesactive}></DailyList>
      </div>
    </div>
  )
}

export default Daily
